var _linearGradient, _path, _path2, _linearGradient2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Gutters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q5khA3dk7fZGWNL4NKQF9a",
    x1: -1.425,
    x2: 20.609,
    y1: 18.5,
    y2: 18.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0176d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16538c"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q5khA3dk7fZGWNL4NKQF9a)",
    d: "M23,29h-7C9.935,29,5,24.065,5,18V8h10v10c0,0.552,0.449,1,1,1h7V29z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#103f8f",
    d: "M4.961,6h10.003c0.531,0,0.961,0.361,0.961,0.806v2.389c0,0.445-0.43,0.806-0.961,0.806H4.961 C4.43,10,4,9.639,4,9.194V6.806C4,6.361,4.43,6,4.961,6z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q5khA3dk7fZGWNL4NKQF9b",
    x1: 27.914,
    x2: 42.468,
    y1: 19.644,
    y2: 39.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2aa4f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007ad9"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q5khA3dk7fZGWNL4NKQF9b)",
    d: "M43,40H33V30c0-0.552-0.449-1-1-1h-7V19h7c6.065,0,11,4.935,11,11V40z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#095fac",
    d: "M43.039,42H33.036c-0.531,0-0.961-0.361-0.961-0.806v-2.389c0-0.445,0.43-0.806,0.961-0.806h10.003 C43.57,38,44,38.361,44,38.806v2.389C44,41.639,43.57,42,43.039,42z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#103f8f",
    d: "M26,18.967v10.067C26,29.567,25.639,30,25.194,30h-2.389C22.361,30,22,29.567,22,29.033V18.967 C22,18.433,22.361,18,22.806,18h2.389C25.639,18,26,18.433,26,18.967z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Gutters);
export default __webpack_public_path__ + "static/media/icons8-gutters.ad347453156b341258b868fe9dced534.svg";
export { ForwardRef as ReactComponent };